/* Code copyright 2023 (c) Tuva Labs Inc. */

import { useCallback, useState } from "react";

function TextInput({ value, onChange, arialabel, className }) {
    const [inputValue, setInputValue] = useState(value || "");

    const onBlur = useCallback(
        (e) => {
            setInputValue(value);
        },
        [value]
    );

    const onValChange = useCallback(
        (e) => {
            setInputValue(e.target.value);
            onChange(e.target.value);
        },
        [onChange]
    );

    return (
        <input
            type="text"
            className={className}
            aria-label={arialabel}
            onChange={onValChange}
            onBlur={onBlur}
            value={inputValue}
        />
    );
}

export default TextInput;
